const ensureDataLayer = () => {
  window.dataLayer = window.dataLayer ?? [];
  return window.dataLayer;
};

export const initGtm = (gtmIdRaw?: string) => {
  const gtmId = (gtmIdRaw ?? '').trim();
  if (!gtmId) return;

  const scriptId = `gtm-js-${gtmId}`;
  if (document.getElementById(scriptId)) return;

  // Mirror the standard GTM snippet behavior: create the queue and timestamp it.
  ensureDataLayer().push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.id = scriptId;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;

  document.head.appendChild(script);
};
